import { api } from '../api';

export interface IMetricsCards {
  totalUsers: number;
  notVerified: number;
  byRole: { role: number; count: number }[];
  totalGroups: number;
  totalEvents: number;
}

export interface IActivityPoint {
  day: string;
  starts: number;
  finishes: number;
}

export interface IRegistrationPoint {
  day: string;
  count: number;
}

export interface IMetricsResponse {
  cards: IMetricsCards;
  activity: IActivityPoint[];
  registrations: IRegistrationPoint[];
}

export const adminApi = api.injectEndpoints({
  endpoints: builder => ({
    getMetrics: builder.query<IMetricsResponse, number | void>({
      query: (windowDays = 7) => ({ url: `/admin/metrics`, params: { windowDays } }),
    }),

  }),
});


